import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-header-navigation',
  templateUrl: './header-navigation.component.html',
  styleUrls: ['./header-navigation.component.scss']
})
export class HeaderNavigationComponent implements OnInit {

  @Input() enabled: boolean;

  constructor() {
  }

  ngOnInit(): void {
  }
}
